import React, { useEffect } from "react";
import { Button, Form, Input, Space, Select, Switch } from "antd";
import { Platform } from "../../../types/platform";
import { Adapter } from "../../../types/adapter";

const { Option } = Select;

export interface AdapterFormProps {
  adapter?: Adapter;
  isLoading?: boolean;
  onFinish: (adapter: Adapter) => void;
}

export const AdapterForm = (props: AdapterFormProps) => {
  const [form] = Form.useForm();

  const onReset = () => {
    form.resetFields();
  };

  const onFinish = (values: any) => {
    const adapter: Adapter = { ...props.adapter, ...values };
    props.onFinish(adapter);
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(props.adapter);
  }, [props.adapter, form]);

  return (
    <Form
      form={form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 16 }}
      layout="horizontal"
      onFinish={onFinish}
    >
      <Form.Item
        label="Status"
        name="status"
        rules={[{ required: true, message: "Please input status" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="platform" label="Platform">
        <Select style={{ width: 120 }}>
          <Option value={Platform.ANDROID}>Android</Option>
          <Option value={Platform.IOS}>IOS</Option>
        </Select>
      </Form.Item>
      <Form.Item name="version" label="Version">
        <Input />
      </Form.Item>
      <Form.Item name="bidding" label="Bidding">
        <Switch />
      </Form.Item>
      <Form.Item name="adTypes" label="Ad Types">
        <Select mode="multiple">
          <Option value="banner">Banner</Option>
          <Option value="interstitial">Interstitial</Option>
          <Option value="rewarded_video">Rewarded Video</Option>
          <Option value="mrec">MREC</Option>
          <Option value="native">Native</Option>
        </Select>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <Space>
          <Button loading={props.isLoading} type="primary" htmlType="submit">
            {props.adapter ? "Update" : "Create"}
          </Button>
          <Button htmlType="button" onClick={onReset}>
            Reset
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
